import { gql } from '@apollo/client';

export const PaginatedRepacksQuery = gql`
    query PaginatedRepacks(
        $take: Int = 1
        $subType: RepackSubType
        $page: Int
        $query: String
    ) {
        paginatedRepacks(
            take: $take
            subType: $subType
            page: $page
            query: $query
        ) {
            data {
                guid
                artworkUrl
                backgroundColor
                creatorSession
                foregroundColor
                isDownloaded
                isExclusive
                isFavorited
                isFree
                name
                packState
                premiumCodes
                slug
                subType
                type
            }
            meta {
                totalRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
        }
    }
`;

export const REPACK = gql`
    query Repack($repackSlugOrGuid: ID!) {
        repack(repackSlugOrGuid: $repackSlugOrGuid) {
            guid
            artworkUrl
            backgroundColor
            creatorSession
            description
            foregroundColor
            isDownloaded
            isExclusive
            isFavorited
            isFree
            name
            packState
            premiumCodes
            sampleCount
            slug
            subType
            type
            mainGenre {
                code
                subGenres {
                    code
                }
            }
            genres {
                code
                subGenres {
                    code
                }
            }
            sfxs {
                code
                subSfxs {
                    code
                }
            }
            artist {
                guid
                name
                description
                artworkUrl
                portraitUrl
                coverUrl
                isExclusive
                slug
                seoMetadata {
                    title
                    description
                }
            }
            label {
                guid
                name
                description
                artworkUrl
                coverUrl
                isExclusive
                slug
                seoMetadata {
                    title
                    description
                }
            }
            brandtype {
                guid
                name
                slug
            }
            seoMetadata {
                title
                description
            }
        }
    }
`;

export const REPACK_IS_DOWNLOADED_STATE = gql`
    query RepackIsDownloaded($guid: ID!) {
        repack(repackSlugOrGuid: $guid) {
            guid
            isDownloaded
        }
    }
`;

export const PAGINATED_REPACK_SAMPLES_QUERY = gql`
    query PaginatedRepackSamples(
        $repackGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedRepackSamples(
            repackGuid: $repackGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                bpm
                duration
                pack {
                    artworkUrl
                    guid
                    name
                    slug
                    artist {
                        guid
                        slug
                    }
                    label {
                        guid
                        slug
                    }
                }
                sampleType
                key {
                    code
                    root
                    quality
                }
                isFavorited
                isDownloaded
                isRecommendationFiller
                waveformUrl
                credits
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                tags {
                    code
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }

            next {
                skip
            }
        }
    }
`;

export const UPDATE_REPACK_FAVORITED_STATE = gql`
    mutation UpdateRepackFavoritedState($repack: RepackFavoritedInput!) {
        updateRepackFavoritedState(repack: $repack) {
            guid
            isFavorited
        }
    }
`;

export const REPACK_STREAM_QUERY = gql`
    query RepacksStream($repackGuid: ID!) {
        repackStream(repackGuid: $repackGuid) {
            url
        }
    }
`;
